import { TextNode } from 'lexical';
import { ProjectMetadataMap } from 'const/ProjectMetadata';
import { $createProjectMetadataTokenNode } from '../../nodes/ProjectMetadataTokenNode';

const TOKEN_KEYS = new Set(Object.keys(ProjectMetadataMap));

export const $textNodeTransform = (metadata: Record<string, string>) => (node: TextNode): void => {
  if (!node.isSimpleText()) {
    return;
  }

  const text = node.getTextContent();

  if (!text.includes('{{')) {
    return;
  }

  for (const key of TOKEN_KEYS) {
    const token = `{{${key}}}`;
    const startIndex = text.indexOf(token);

    if (startIndex !== -1) {
      const endIndex = startIndex + token.length;
      const metadataTokenNode = $createProjectMetadataTokenNode(key, metadata);

      if (metadataTokenNode) {
        let targetNode: TextNode;

        if (startIndex === 0) {
          [targetNode] = node.splitText(endIndex);
        } else {
          [, targetNode] = node.splitText(startIndex, endIndex);
        }

        metadataTokenNode.setStyle(targetNode.getStyle());
        targetNode.replace(metadataTokenNode);
      }

      return;
    }
  }
};
